export default {
  // 人员矩阵
  personnelMatrix: {
    //流程配置器
    personnelMatrix: '人員矩陣',
    matrixConfiguration: '矩陣配置',
    selectMatrix: '選擇人員矩陣',
    selectMappingRelationship: '選擇映射關係',
    selectPersonnelMaintenance: '選擇人員維護',
    selectReferenceDep: '選擇參照部門',
    formData: '表單數據',
    selectApprovalPersonnel: '選擇審批人員',
    jobPosSelect: '崗位選擇',
    placeholder: {
      matrix: '請選擇矩陣',
      depCompoment: '請選擇部門組件',
      josPos: '請選擇崗位'
    },
    personnelMatrixNote:
      '對於人員較多,關係較複雜的公司,人員矩陣設定可以滿足多維度人員關係對應的需求',
    searchPlaceholder: '搜索矩陣名稱或編碼',
    noData: '暫無數據',
    referenceQuery: '引用查詢',
    addMatrix: '新增矩陣',
    matrixName: '矩陣名稱',
    matrixCode: '矩陣編碼',
    delMatrixReferenceTip: '請先在【審批流程】中清空數據後進行刪除',
    changeMatrixStatusReferenceTip: '請先在【審批流程】中清空或刪除引用後進行關閉',
    jobMaintenance: '崗位維護',
    mappingRelationship: '映射關係',
    jobMaintenanceTip: '先維護崗位矩陣中所涉及的各個審批崗位,再維護映射關係',
    addJobPosition: '添加崗位',
    editJobPosition: '編輯崗位',
    jobPositionName: '崗位名稱',
    jobPositionCode: '崗位編碼',
    editJobPositionEmptyTip: '崗位不存在',
    delJobPosImportTip: '請先在【映射關係】中清空人員數據後進行刪除',
    // 映射關係頁面
    orgProtection: '崗位維護',
    removeFilter: '篩選移除',
    department: '部門',
    position1: '崗位1',
    position2: '崗位2',
    position3: '崗位3',
    selectOrgTip: '請選擇左側組織節點查看映射關係',
    mappingTip: '崗位維護中成員,綁定該{dept}個對應的{count}位人員',
    batchMaintenance: '批量維護',
    exportMatrix: '導出矩陣',
    selectPersonnel: '選擇人員',
    searchPersonnel: '搜索人員',
    add: '新增',
    syncReplaceChildren: '同步替換下級',
    // 批量維護彈窗
    downloadLatestTemplate: '下載最新模板',
    importTemplate: '導入模板',
    complete: '完成',
    prepareImportData: '請按照數據模版的格式準備要導入的數據',
    batchMaintenanceNote1: '模版中的表頭名稱不可更改, 表頭行不能刪除, 行內容不可刪除或增加',
    batchMaintenanceNote2: '導入格式為xlsx, 數據導入為覆蓋導入',
    batchMaintenanceNote3:
      '人員必須為組織架構內存在的人員工號, 否則導入失敗, 每次必須下載最新模板; 多人用英文, 隔開',
    clickDownloadTemplate: '點擊下載最新導入模板',
    selectImportTemplate: '請選擇需要導入的數據模版',
    addFile: '添加文件',
    fileName: '文件名稱',
    previousStep: '上一步',
    startImport: '開始導入',
    addSuccess: '添加成功',
    importExceptionDescription: '導入異常說明',
    serialNumber: '序號',
    listHeaderAdjusted: '列表頭字段有調整',
    rowHeaderAdjusted: '行表頭字段有調整',
    personnelNotExist: '人員不存在',
    mattersNeedingAttention: '注意事項',
    nextStep: '下壹步',
    onlyOneFile: '每次僅允許上傳1個文件',
    pleaseSelectFile: '請選擇文件',
    downloadStart: '開始下載',
    importFailed: '導入失敗',
    exportSuccess: '導出成功',
    exportFailed: '導出失敗'
  }
}
